import { allowedUserType, eventQuota, isVerifiedByCoreEvent, modulesRequired } from '../rules'

import TheaterEventTemplateInfoContainer from '@/components/events/TheaterEventTemplateInfoContainer.vue'
import TheaterPerformancesContainer from '@/components/events/TheaterPerformancesContainer.vue'
import MailingList from '@/components/organizations/MailingList.vue'
import MembersList from '@/components/organizations/memberships/MembersList.vue'
import MembershipsContainer from '@/components/organizations/memberships/MembershipsContainer.vue'
import ReportsContainer from '@/components/organizations/reports/ReportsContainer.vue'
import OrganizerPayoutsContainer from '@/components/organizations/payouts/OrganizerPayoutsContainer.vue'
import SubscriptionsList from '@/components/organizations/subscriptions/SubscriptionsList.vue'
import SubscriptionsPlanContainer from '@/components/organizations/subscriptions/SubscriptionsPlanContainer.vue'
import TheaterOrganizationSidebar from '@/components/shared/sidebars/theater-organization/TheaterOrganizationSidebar.vue'
import {
  theaterOrganizationRouteNames,
  theaterOrganizerRouteNames,
} from '@/routing/routeNames/theaterOrganizerRouterNames'
import CustomSuccessfulPayment from '../../components/accreditations/CustomSuccessfulPayment.vue'
import SuccessfulPayment from '../../components/accreditations/SuccessfulPayment.vue'
import OrganizationCreateContainer from '../../components/organizations/OrganizationCreateContainer.vue'
import OrganizationsListContainer from '../../components/organizations/OrganizationsListContainer.vue'
import OrganizationLiveEventsListContainer from '../../components/organizations/events/OrganizationLiveEventsListContainer.vue'
import OrganizationPastEventsListContainer from '../../components/organizations/events/OrganizationPastEventsListContainer.vue'
import genres from '../../components/organizations/genres-and-tags/genres.vue'
import tags from '../../components/organizations/genres-and-tags/tags.vue'
import PromoCodeInfoContainer from '../../components/organizations/promo-codes/PromoCodeInfoContainer.vue'
import PromoCodesContainer from '../../components/organizations/promo-codes/PromoCodesContainer.vue'
import TicketType from '../../components/organizations/ticket-types/TicketTypeContainer.vue'
import TheaterTicketStatistics from '../../components/stats/theater-ticket-statistic-container.vue'
import TheaterTicketListContainer from '../../components/tickets/TheaterTicketListContainer.vue'
import { mainRouteNames } from '../routeNames/mainRouteNames'
import { getPropsFromParams } from '../utils.routing'
import AccreditationUpdateContainer from './../../components/accreditations/AccreditationUpdateContainer.vue'
import TheaterSubscriptionPassDetailsContainer from './../../components/accreditations/TheaterSubscriptionPassDetailsContainer.vue'
import EventRequestsContainer from './../../components/accreditations/EventRequestsContainer.vue'
import TheaterAccreditationsListContainer from './../../components/accreditations/TheaterAccreditationListContainer.vue'
import TheaterInviteAttendeesContainer from './../../components/accreditations/TheaterInviteAttendeeContainer.vue'
import InviteEditContainer from './../../components/accreditations/invite/InviteEditContainer.vue'
import AttendeeFieldsContainer from './../../components/events/AttendeeFieldsContainer.vue'
import EventCategoriesContainer from './../../components/events/EventCategoriesContainer.vue'
import EventCreateContainer from './../../components/events/EventCreateContainer.vue'
import EventsListContainer from './../../components/events/EventsListContainer.vue'
import OrganizationEventsListContainer from './../../components/events/OrganizationEventsListContainer.vue'
import ImportContainer from './../../components/import-export/ImportContainer.vue'
import Subscribers from './../../components/organizations/mailing-list/subscribers.vue'
import OrganizerSidebar from './../../components/shared/sidebars/organizer/OrganizerSidebar.vue'
import TheaterScannedTicketsContainer from './../../components/stats/theater-scanned-ticket-container.vue'
import TheaterVisitorStatsContainer from './../../components/stats/visitor/theater-visitor-statistic-container.vue'
import InviteContainer from './../../components/user/InviteContainer.vue'
import OrganizerProfileContainer from './../../components/user/OrganizerProfileContainer.vue'
import TrialAccountInviteContainer from './../../components/user/TrialAccountInviteContainer.vue'
import OrganizerFinanceInfo from './../../components/user/finance-info.vue'
import TheaterImportExportContainer from '@/components/import-export/TheaterImportExportContainer.vue'
import TheaterExportContainer from '@/components/import-export/TheaterExportContainer.vue'
import TheaterEmailsListContainer from '@/components/emails/TheaterEmailsListContainer.vue'
import TheaterEmailCreateContainer from '@/components/emails/TheaterEmailCreateContainer.vue'
import TheaterEmailUpdateContainer from '@/components/emails/TheaterEmailUpdateContainer.vue'
import TheaterEmailDetailsContainer from '@/components/emails/TheaterEmailDetailsContainer.vue'
import TheaterFloorPlanOverview from '@/components/stats/theater-floor-plan-overview.vue'
import TheaterDocumentationContainer from '@/components/event-documentation/TheaterDocumentationContainer.vue'
import LegalEntityInvoicesContainer from '@/components/event-documentation/LegalEntityInvoicesContainer.vue'
import DesignWebshopTicketContainer from '@/components/tickets/design-webshop-ticket-container.vue'
import TheaterSubscriptionsList from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsList.vue'
import TheaterSubscriptionsCreateEmail from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsCreateEmail.vue'
import TheaterSubscriptionsEmails from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsEmails.vue'
import TheaterSubscriptionsEmailDetails from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsEmailDetails.vue'
import TheaterSubscriptionsPlanContainer from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsPlanContainer.vue'
import CreateTheaterSubscriptionPlan from '@/components/organizations/theaterSubscriptions/CreateTheaterSubscriptionPlan.vue'
import TheaterSubscriptionReports from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionReports.vue'
import TheaterSubscriptionReportsPrintable from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionReportsPrintable.vue'
import TheaterSubscriptionsFloorPlan from '@/components/organizations/theaterSubscriptions/TheaterSubscriptionsFloorPlan.vue'
import BundleOffersContainer from '@/components/organizations/bundle-offers/BundleOffersContainer.vue'
import TheaterOrganizationUsers from '@/components/organizations/users/theater-organization-users.vue'
const theaterDashboardSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/dashboard',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventDashboardTheater,
    component: TheaterTicketStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Ticket statistics',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/floor-plan-overview',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.theaterFloorPlanOverview,
    component: TheaterFloorPlanOverview,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan overview',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/stats/visitors',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.visitorStatisticsTheater,
    component: TheaterVisitorStatsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Visitor statistics',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/stats/scanned',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.scannedTicketsTheater,
    component: TheaterScannedTicketsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Scanned tickets',
    },
  },
]

const attendeeListSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/accreditations',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.accreditationsTheater,
    component: TheaterAccreditationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee list',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/:eventId/accreditation/:accreditationUuid/edit',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.editAccreditationTheater,
    component: AccreditationUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update Accreditation',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/:eventId/subscription-pass/:accreditationUuid',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.theaterSubscriptionPassDetails,
    component: TheaterSubscriptionPassDetailsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Subscription pass details',
    },
  },
]

const importExportSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.importExportTheater,
    component: TheaterImportExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'What do you need?',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data/import',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.importTheater,
    component: ImportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Import',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data/export',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.exportTheater,
    component: TheaterExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Export',
    },
  },
]

const emailsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.emailsTheater,
    component: TheaterEmailsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Emails to attendees',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/new',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.createEmailTheater,
    component: TheaterEmailCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Create email',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/:emailId/details',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.emailDetailsTheater,
    component: TheaterEmailDetailsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Email details',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/:emailId/update',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.updateEmailTheater,
    component: TheaterEmailUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Update automated email',
    },
  },
]

const inviteAttendeesSidebarRoute = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/invite-attendee',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.inviteAttendeeTheater,
    component: TheaterInviteAttendeesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Invite attendees',
    },
  },
]

const pendingRequestsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/requests',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.requestsTheater,
    component: EventRequestsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendance requests',
    },
  },
]

const editInviteSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/edit-invite',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.editInviteTheater,
    component: InviteEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Edit invite information',
    },
  },
]

const ticketsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/tickets',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.ticketsTheater,
    component: TheaterTicketListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Tickets',
    },
  },
]

const designWebshopTicketSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/design-webshop-ticket',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.designWebshopTicketTheater,
    component: DesignWebshopTicketContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Design webshop tickets',
    },
  },
]

const eventInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/info',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventInfoTheater,
    component: TheaterEventTemplateInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Event info',
    },
  },
]

const theaterPerformance = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/performances',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.theaterPerformance,
    component: TheaterPerformancesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'TheaterPerformance',
    },
  },
]

const documentationSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/documentation',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventDocumentationTheater,
    component: TheaterDocumentationContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Documentation',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/:eventId/legal-entity-invoices',
    name: theaterOrganizerRouteNames.eventLegalEntityInvoicesTheater,
    props: getPropsFromParams,
    component: LegalEntityInvoicesContainer,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN', 'REGULAR'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]

const categoriesSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/categories',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventCategoriesTheater,
    component: EventCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['categoriesAndZones'])],
      title: 'Categories',
    },
  },
]

const attendeeFieldsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/attendee-fields',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.attendeeFieldsTheater,
    component: AttendeeFieldsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee fields',
    },
  },
]

const theaterOrganizationEventsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/live-events',
    name: theaterOrganizationRouteNames.theaterLiveEvents,
    props: getPropsFromParams,
    component: OrganizationLiveEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Live events',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/past-events',
    name: theaterOrganizationRouteNames.theaterPastEvents,
    props: getPropsFromParams,
    component: OrganizationPastEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Past events',
    },
  },
]
const theaterOrganizationGenresAndTagsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/genres',
    name: theaterOrganizationRouteNames.theaterOrganizationGenres,
    props: getPropsFromParams,
    component: genres,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Genres',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/tags',
    name: theaterOrganizationRouteNames.theaterOrganizationTags,
    props: getPropsFromParams,
    component: tags,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Tags',
    },
  },
]
const theaterOrganizationSubscriptionsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/subscriptions-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationSubscriptionsPlan,
    props: getPropsFromParams,
    component: SubscriptionsPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions plan',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/subscriptions-list',
    name: theaterOrganizationRouteNames.theaterOrganizationSubscriptionsList,
    props: getPropsFromParams,
    component: SubscriptionsList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions list',
    },
  },
]

const theaterOrganizationTheaterSubscriptionsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsPlan,
    props: getPropsFromParams,
    component: TheaterSubscriptionsPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Theater Subscriptions plan',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-plan/create',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsPlanCreate,
    props: getPropsFromParams,
    component: CreateTheaterSubscriptionPlan,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Create Theater Subscription Plan',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscribers/emails',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscribersEmails,
    props: getPropsFromParams,
    component: TheaterSubscriptionsEmails,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Emails to Subscribers',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscribers/emails/:emailId',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscribersEmailDetails,
    props: getPropsFromParams,
    component: TheaterSubscriptionsEmailDetails,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Email details',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscribers/message',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscribersMessage,
    props: getPropsFromParams,
    component: TheaterSubscriptionsCreateEmail,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Message subscribers',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-list',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsList,
    props: getPropsFromParams,
    component: TheaterSubscriptionsList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Theater Subscriptions list',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-floor-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsFloorPlan,
    props: getPropsFromParams,
    component: TheaterSubscriptionsFloorPlan,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Floor plan',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-reports',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsReports,
    props: getPropsFromParams,
    component: TheaterSubscriptionReports,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription reports',
    },
  },
]

const theaterOrganizationMembershipsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/membership-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationMemberships,
    props: getPropsFromParams,
    component: MembershipsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Memberships',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/members-list',
    name: theaterOrganizationRouteNames.theaterOrganizationMembersList,
    props: getPropsFromParams,
    component: MembersList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Members list',
    },
  },
]

const theaterOrganizationInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/organization-info',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationProfileInfo,
    component: OrganizerProfileContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Organization info',
    },
  },
]

const theaterOrganizationUsersSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/organization-users',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationUsers,
    component: TheaterOrganizationUsers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      allowedOrganizationRoles: ['OWNER', 'ADMIN'],
      title: 'Users',
    },
  },
]

const theaterOrganizationTicketTypeSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/ticket-type',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationTicketType,
    component: TicketType,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Ticket types',
    },
  },
]

const theaterOrganizationMailingListSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/mailing-list',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationMailingList,
    component: MailingList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Mailing list',
    },
  },
]

const theaterFinanceInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/finance-info',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationFinanceInfo,
    component: OrganizerFinanceInfo,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Finance info',
    },
  },
]

const theaterPayoutsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/payouts',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationPayouts,
    component: OrganizerPayoutsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['SUPER_ADMIN'])],
      title: 'Payouts',
    },
  },
]

const theaterSubscribersSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/subscribers',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationSubscribers,
    component: Subscribers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscribers',
    },
  },
]

const theaterTicketingDealsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/promo-codes',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationPromoCodes,
    component: PromoCodesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo codes',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/promo-codes/:promoCodeId',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationPromoCodeInfo,
    component: PromoCodeInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo code',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/bundle-offers',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationBundleOffers,
    component: BundleOffersContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Bundle offers',
    },
  },
]

const theaterOrganizationSidebarRoutes = [
  ...theaterOrganizationEventsSidebarRoutes,
  ...theaterOrganizationTicketTypeSidebarRoutes,
  ...theaterOrganizationSubscriptionsSidebarRoutes,
  ...theaterOrganizationTheaterSubscriptionsSidebarRoutes,
  ...theaterOrganizationMailingListSidebarRoutes,
  ...theaterOrganizationInfoSidebarRoutes,
  ...theaterOrganizationUsersSidebarRoutes,
  ...theaterFinanceInfoSidebarRoutes,
  ...theaterPayoutsSidebarRoutes,
  ...theaterSubscribersSidebarRoutes,
  ...theaterOrganizationGenresAndTagsSidebarRoutes,
  ...theaterTicketingDealsSidebarRoutes,
  ...theaterOrganizationMembershipsSidebarRoutes,
]

const theaterOrganizerSidebarRoutes = [
  ...theaterDashboardSidebarRoutes,
  ...theaterPerformance,
  ...attendeeListSidebarRoutes,
  ...documentationSidebarRoutes,
  ...importExportSidebarRoutes,
  ...emailsSidebarRoutes,
  ...inviteAttendeesSidebarRoute,
  ...pendingRequestsSidebarRoutes,
  ...editInviteSidebarRoutes,
  ...ticketsSidebarRoutes,
  ...designWebshopTicketSidebarRoutes,
  ...eventInfoSidebarRoutes,
  ...categoriesSidebarRoutes,
  ...attendeeFieldsSidebarRoutes,
]

const nonSidebarRoutes = [
  {
    path: '/events',
    name: theaterOrganizerRouteNames.eventsTheater,
    props: getPropsFromParams,
    component: EventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/events',
    name: theaterOrganizationRouteNames.theaterOrganizationWorkingEvents,
    props: getPropsFromParams,
    component: OrganizationEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/',
    name: theaterOrganizerRouteNames.organizationsTheater,
    props: getPropsFromParams,
    component: OrganizationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      allowDashboardNewsModal: true,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/theater-organizations/new',
    name: theaterOrganizerRouteNames.createOrganizationTheater,
    component: OrganizationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/events/new',
    name: theaterOrganizationRouteNames.theaterOrganizationAddEvent,
    props: getPropsFromParams,
    component: EventCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [eventQuota(), allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/invite/:inviteToken',
    name: theaterOrganizerRouteNames.inviteTheater,
    component: InviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
    props: getPropsFromParams,
  },
  {
    path: '/create-trial-account',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.createTrialAccountTheater,
    component: TrialAccountInviteContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      hideProAccountButton: true,
    },
  },
  {
    path: '/successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.successfulPaymentTheater,
    component: SuccessfulPayment,
    meta: {
      cookieBanner: true,
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/custom-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.customSuccessfulPaymentTheater,
    component: CustomSuccessfulPayment,
    meta: {
      cookieBanner: true,
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/reports',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationReports,
    component: ReportsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Reports',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/theater-subscriptions-reports/print',
    name: theaterOrganizationRouteNames.theaterOrganizationTheaterSubscriptionsReportsPrint,
    props: getPropsFromParams,
    component: TheaterSubscriptionReportsPrintable,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription reports printable',
    },
  },
]

export const TheaterOrganizerRoutes = [
  ...nonSidebarRoutes,
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId',
    redirect: { name: theaterOrganizerRouteNames.eventDashboardTheater },
    name: mainRouteNames.theaterOrganizerSidebar,
    props: getPropsFromParams,
    component: OrganizerSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
      allowDashboardNewsModal: true,
    },
    children: theaterOrganizerSidebarRoutes,
  },
  {
    path: '/theater-organizations/:organizationSlug',
    redirect: { name: theaterOrganizationRouteNames.theaterLiveEvents },
    name: mainRouteNames.theaterOrganizationSidebar,
    props: getPropsFromParams,
    component: TheaterOrganizationSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
      allowDashboardNewsModal: true,
    },
    children: theaterOrganizationSidebarRoutes,
  },
]
